import { StackProps } from "react-bootstrap";
import { ProjectPackageSummaryVM } from "../../../../api/generated/models";
import { ITestableComponentProps } from "../../../../shared/types/testing.types";

export interface IPackageListProps extends StackProps, ITestableComponentProps {
  packageList?: Array<ProjectPackageSummaryVM>;
}

export const DefaultPackageListProps: IPackageListProps = {
  packageList: undefined,
};
